import type { ArticleSearchCategory } from '#lib/websites/news/constants/categories.js';
import type { METRICS } from '#lib/websites/news/constants/dashboard.js';
import { CATEGORY_METRICS_MAP } from '#lib/websites/news/constants/dashboard.js';

export const areMetricAndCategoryConsistent = (
	metric: METRICS,
	category?: ArticleSearchCategory
) => {
	const categoryToMatch = (
		CATEGORY_METRICS_MAP[metric] as { category?: ArticleSearchCategory }
	)?.category;

	if (!CATEGORY_METRICS_MAP[metric]) {
		return false;
	}

	if (!categoryToMatch) {
		return !category;
	}

	return category === categoryToMatch;
};
